import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import { alpha } from '@mui/material/styles';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
import { PondLogsLogo } from './PondLogsLogo';
const navItems = [
    { key: 'dashboard', labelKey: 'navigation.dashboard' },
    { key: 'monitor', labelKey: 'navigation.monitor' },
    { key: 'ponds', labelKey: 'navigation.ponds' },
    { key: 'operations', labelKey: 'navigation.operations' },
    { key: 'analytics', labelKey: 'navigation.analytics' },
    { key: 'settings', labelKey: 'navigation.settings' },
    { key: 'help', labelKey: 'navigation.help' },
];
const NavItemIcon = (props) => {
    const { itemKey } = props;
    const color = 'currentColor';
    const svgStyle = {
        width: '20px',
        height: '20px',
        stroke: color,
        strokeWidth: 2,
        strokeLinecap: 'round',
        fill: 'none',
    };
    switch (itemKey) {
        case 'dashboard':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "14", y: "3", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" })] }));
        case 'monitor':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("path", { d: "M15 17h5l-1.4-1.4a2 2 0 0 1-.6-1.4V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5" }), _jsx("path", { d: "M9 17a3 3 0 0 0 6 0" })] }));
        case 'ponds':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("path", { d: "M3 7c1.5 1.3 3 1.3 4.5 0s3-1.3 4.5 0 3 1.3 4.5 0 3-1.3 4.5 0" }), _jsx("path", { d: "M3 12c1.5 1.3 3 1.3 4.5 0s3-1.3 4.5 0 3 1.3 4.5 0 3-1.3 4.5 0" }), _jsx("path", { d: "M3 17c1.5 1.3 3 1.3 4.5 0s3-1.3 4.5 0 3 1.3 4.5 0 3-1.3 4.5 0" })] }));
        case 'operations':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("rect", { x: "5", y: "4", width: "14", height: "17", rx: "2" }), _jsx("path", { d: "M9 4.5h6" }), _jsx("path", { d: "M9 10h6" }), _jsx("path", { d: "M9 14h6" })] }));
        case 'analytics':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("path", { d: "M3 3v18h18" }), _jsx("path", { d: "M8 17V9" }), _jsx("path", { d: "M13 17V5" }), _jsx("path", { d: "M18 17v-7" })] }));
        case 'settings':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("circle", { cx: "12", cy: "12", r: "3" }), _jsx("path", { d: "M19.4 15a1 1 0 0 0 .2 1.1l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 1 1-4 0v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 1 1 0-4h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1 1 0 0 0 1.1.2h.1a1 1 0 0 0 .6-.9V4a2 2 0 1 1 4 0v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1 1 0 0 0-.2 1.1v.1a1 1 0 0 0 .9.6H20a2 2 0 1 1 0 4h-.2a1 1 0 0 0-.4 1.5" })] }));
        case 'help':
            return (_jsxs("svg", { viewBox: "0 0 24 24", style: svgStyle, children: [_jsx("circle", { cx: "12", cy: "12", r: "9" }), _jsx("path", { d: "M9.5 9a2.5 2.5 0 1 1 4 2c-.8.6-1.5 1.2-1.5 2.5" }), _jsx("path", { d: "M12 17h.01" })] }));
        default:
            return null;
    }
};
export const NavigationPanel = memo((props) => {
    const { t } = useTranslation('main');
    const { activeMainView, onNavItemClick, onClose, collapsed = false } = props;
    const isItemActive = (key) => {
        if (key === 'dashboard')
            return activeMainView === 'dashboard';
        if (key === 'help')
            return activeMainView === 'help';
        if (key === 'ponds')
            return activeMainView === 'ponds';
        if (key === 'settings')
            return activeMainView === 'settings';
        return false;
    };
    if (collapsed) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                alignItems: 'center',
                pt: '6px',
                pb: 1.5,
                position: 'relative',
            }, children: [_jsx(Box, { sx: {
                        width: '100%',
                        px: 0.5,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }, children: _jsxs(Box, { onClick: onClose, sx: {
                            width: 32,
                            height: 32,
                            borderRadius: '40%',
                            bgcolor: colorTokens.accent,
                            color: colorTokens.primary,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            cursor: onClose ? 'pointer' : 'default',
                            position: 'relative',
                            '& .pl-logo': { opacity: 1, transition: 'opacity 0.15s' },
                            '& .pl-hamburger': {
                                opacity: 0,
                                transition: 'opacity 0.15s',
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            },
                            '&:hover .pl-logo': { opacity: onClose ? 0 : 1 },
                            '&:hover .pl-hamburger': { opacity: onClose ? 1 : 0 },
                        }, children: [_jsx(Box, { className: "pl-logo", children: _jsx(PondLogsLogo, { color: colorTokens.primary, width: 18, height: 13 }) }), _jsx(Box, { className: "pl-hamburger", children: _jsx(MenuIcon, { sx: { fontSize: 17, color: colorTokens.primary } }) })] }) }), _jsx(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0.75,
                        alignItems: 'center',
                        width: '100%',
                        px: 1,
                    }, children: navItems.map((item) => {
                        const active = isItemActive(item.key);
                        return (_jsx(Button, { onClick: () => onNavItemClick(item.key), sx: {
                                width: 40,
                                height: 40,
                                minWidth: 40,
                                p: 0,
                                borderRadius: '10px',
                                color: (theme) => active ? theme.palette.common.white : alpha(theme.palette.common.white, 0.74),
                                bgcolor: (theme) => active ? alpha(theme.palette.common.white, 0.15) : 'transparent',
                                borderLeft: active ? '3px solid' : '3px solid transparent',
                                borderColor: active ? colorTokens.magenta : 'transparent',
                                '&:hover': {
                                    bgcolor: (theme) => alpha(theme.palette.common.white, 0.1),
                                },
                                position: 'relative',
                            }, children: _jsx(Box, { sx: {
                                    width: 20,
                                    height: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }, children: _jsx(NavItemIcon, { itemKey: item.key, active: active }) }) }, item.key));
                    }) })] }));
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            position: 'relative',
        }, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    minHeight: '2.75rem',
                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
                }, children: [_jsx(Box, { sx: {
                            width: 32,
                            height: 32,
                            borderRadius: '40%',
                            bgcolor: 'accent.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }, children: _jsx(PondLogsLogo, { color: colorTokens.primary, width: 18, height: 13 }) }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column' }, children: [_jsx(Typography, { variant: "body2", color: "common.white", sx: { fontWeight: 700, fontSize: '0.875rem', lineHeight: 1.1 }, children: "PondLogs" }), _jsx(Typography, { variant: "caption", sx: {
                                    color: (theme) => alpha(theme.palette.common.white, 0.6),
                                    mt: 0.1,
                                    fontSize: '0.7rem',
                                    fontWeight: 500,
                                    lineHeight: 1.2,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }, children: "Smart Aquaculture" })] }), onClose && (_jsx(Box, { onClick: onClose, sx: {
                            ml: 'auto',
                            width: 28,
                            height: 28,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 1.5,
                            cursor: 'pointer',
                            color: (theme) => alpha(theme.palette.common.white, 0.7),
                            '&:hover': {
                                bgcolor: (theme) => alpha(theme.palette.common.white, 0.12),
                                color: (theme) => theme.palette.common.white,
                            },
                        }, children: _jsx(MenuIcon, { sx: { fontSize: 18 } }) }))] }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', p: 1.25, gap: 0.5 }, children: navItems.map((item) => {
                    const active = isItemActive(item.key);
                    return (_jsxs(Button, { onClick: () => onNavItemClick(item.key), fullWidth: true, sx: {
                            justifyContent: 'flex-start',
                            gap: 1.5,
                            px: 1.5,
                            py: 1,
                            height: 'auto',
                            fontSize: 14,
                            fontWeight: 500,
                            color: (theme) => active ? theme.palette.common.white : alpha(theme.palette.common.white, 0.74),
                            bgcolor: (theme) => active ? alpha(theme.palette.common.white, 0.15) : 'transparent',
                            borderRadius: 2,
                            position: 'relative',
                            borderLeft: active ? '3px solid' : '3px solid transparent',
                            borderColor: active ? colorTokens.magenta : 'transparent',
                            '&:hover': { bgcolor: (theme) => alpha(theme.palette.common.white, 0.1) },
                            textTransform: 'none',
                        }, children: [_jsx(Box, { sx: {
                                    width: 20,
                                    height: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }, children: _jsx(NavItemIcon, { itemKey: item.key, active: active }) }), _jsx(Box, { sx: { flex: 1, textAlign: 'left' }, children: t(item.labelKey) })] }, item.key));
                }) })] }));
});
